import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { bindActionCreators } from 'redux';
import { Typography } from '@material-ui/core';
import ReactSelectMaterialUi from 'react-select-material-ui';
import CloseButton from '../../components/atoms/CloseButton';
import ShopDetailTableGroup from '../../components/molecules/ShopDetailTableGroup';
import { languages, languageType } from '../../constants/Language';

const styles = {
  root: {
    // position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    // left: '2%',
    backgroundColor: '#fff',
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4
  },
  titleDetail: {
    fontSize: 20,
    fontWeight: 'bold',
    margin: 40,
    marginBottom: 20
  },
  btnClose: {
    margin: '0px 30px 30px 30px'
  },
  selectControl: {
    width: '100%'
  },
  selectContainer: {
    marginLeft: '40px',
    marginRight: '40px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    detail,
    updateOpenDetailModal,
    roles,
    isLanguage,
    setIsLanguage,
    isFukuoka,
    groupDisplayLimit
  }) => {
    const closeAction = () => updateOpenDetailModal(false);
    const multiLangDetail = { ...detail };
    if (isLanguage !== languageType.ORIGIN) {
      const languageData = detail.otherLanguages.find(
        language => language.language === isLanguage
      );
      if (languageData) {
        Object.assign(multiLangDetail, languageData.params);
      }
    }
    return (
      <div className={classes.root}>
        <Typography variant="h6" className={classes.titleDetail}>
          {isFukuoka ? '教室情報詳細' : '店舗情報 詳細'}
        </Typography>
        <div className={classes.selectContainer}>
          <ReactSelectMaterialUi
            required
            className={[classes.textField, classes.selectControl]}
            defaultValue={isLanguage}
            value={isLanguage}
            options={languages}
            margin="normal"
            onChange={v => {
              if (isLanguage === v) {
                return;
              }
              setIsLanguage(v);
            }}
          />
        </div>
        <div>
          <ShopDetailTableGroup
            detail={multiLangDetail}
            roles={roles}
            isFukuoka={isFukuoka}
            groupDisplayLimit={groupDisplayLimit}
          />
        </div>
        <div>
          <CloseButton
            className={classes.btnClose}
            onClickAction={closeAction}
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
